import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "text-box"
};
const _hoisted_2 = {
  class: "course-name text-overflow"
};
const _hoisted_3 = {
  class: "course-info"
};
const _hoisted_4 = {
  class: "info-item text-overflow"
};
const _hoisted_5 = {
  key: 0,
  class: "info-item text-overflow"
};
const _hoisted_6 = {
  class: "info-item text-overflow"
};
const _hoisted_7 = {
  class: "watch-num"
};
export default {
  __name: 'CourseCard',
  props: {
    courseItem: Object,
    index: Number
  },
  setup(__props) {
    const props = __props;
    const courseBg = require(`@/assets/images/course/course_bg${props.index % 8 + 1}.png`);
    const goDetail = siteId => {
      localStorage.setItem('currentUrl', document.URL);
      window.location.href = `/courseDetail.html?siteId=${siteId}`;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "course-card",
        style: _normalizeStyle({
          backgroundImage: __props.courseItem.coverImag ? `url(${__props.courseItem.coverImag})` : 'url(' + _unref(courseBg) + ')',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }),
        onClick: _cache[0] || (_cache[0] = $event => goDetail(__props.courseItem.siteId))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.courseItem.course_name), 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "name-line"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(__props.courseItem.organ_name), 1), __props.courseItem.organ_name && __props.courseItem.realname ? (_openBlock(), _createElementBlock("span", _hoisted_5, "  ·  ")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(__props.courseItem.realname), 1)])]), _createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "查看 ", -1)), _createElementVNode("span", null, _toDisplayString(__props.courseItem.showCount), 1)])])], 4);
    };
  }
};